import React, { useState, useEffect } from 'react';

const OurPartnerExport = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const partners = [
    { name: 'Lowe\'s', logo: '/img/partners/p1.png', alt: 'Lowe\'s Partner' },
    { name: 'Walmart', logo: '/img/partners/p2.png', alt: 'Walmart Partner' },
    { name: 'Home Depot', logo: '/img/partners/p3.png', alt: 'Home Depot Partner' },
    { name: 'sam\'s club', logo: '/img/partners/p4.png', alt: 'Sam\'s club' },
  ];

  const capabilities = [
    'Manufacturing',
    'Inventory Management',
    'Retail Execution'
  ];

  return (
    <section id="partners" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-[#215f9a] uppercase tracking-wider">Trusted By Industry Leaders</span>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
            Our Partners & Experience
          </h1>
          <div className="w-16 h-1 bg-[#215f9a] mx-auto"></div>
        </div>

        {/* Capabilities Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {capabilities.map((capability, idx) => (
            <div
              key={idx}
              className="px-5 py-2 bg-[#215f9a] text-white font-semibold text-sm rounded-md"
            >
              {capability}
            </div>
          ))}
        </div>

        {/* Partners Grid - 4 Partners */}
        <div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
            {partners.map((partner, idx) => (
              <div
                key={idx}
                className="group cursor-pointer"
              >
                <div className="aspect-square bg-gray-50 rounded-lg flex items-center justify-center transition-all duration-200 group-hover:shadow-md group-hover:scale-105 p-4 border border-gray-100">
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    className="max-w-full max-h-full object-contain  group-hover:grayscale-0 transition-all duration-200"
                    onError={(e) => {
                      e.target.src = `https://placehold.co/120x120/e2e8f0/64748b?text=${partner.name.charAt(0)}`;
                    }}
                  />
                </div>
                <p className="text-center mt-2 text-gray-600 text-xs font-medium">
                  {partner.name}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Experience Section */}
        <div className="mt-16">
          <div className="bg-gray-50 rounded-lg p-8 md:p-10 text-center">
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 rounded-lg bg-[#215f9a] flex items-center justify-center">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
              Years of Excellence
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed text-sm">
              With over 16 years of manufacturing expertise and strategic partnerships with North America's leading retailers, 
              we deliver exceptional quality, reliability, and innovation in every product.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPartnerExport;